import '../../src/js/components/accordions';
